/**
 * useWebSocket Hook
 *
 * Ensures WebSocket connection is established when user is authenticated.
 * Subscribes to task and operator channels to keep stores in sync.
 * Call from the main layout so it runs once for all authenticated pages.
 */

import { useEffect } from 'react';
import { getAccessToken } from '@/stores/auth';
import { wsService } from '@/services/websocket';
import { useTasksStore } from '@/stores/tasks';
import { useOperatorsStore } from '@/stores/operators';

export function useWebSocket() {
  useEffect(() => {
    const token = getAccessToken();
    if (!token || wsService.isConnected) return;

    wsService.connect();

    // Subscribe to task updates — merge into store in real-time
    const unsubTasks = wsService.subscribeTasks((data: any) => {
      if (data?.taskId) {
        useTasksStore.getState().handleTaskUpdate(data);
      }
    });

    // Subscribe to operator updates — refetch operator list
    const unsubOps = wsService.subscribeOperators(() => {
      useOperatorsStore.getState().fetchOperators();
    });

    return () => {
      unsubTasks();
      unsubOps();
    };
  }, []);
}
